<template>
    <div class="row">
        <h1 class="mt-4"><a :href="'http://' + gym.url_ident" target="_blank">{{ gym.title }}</a></h1>
        <hr>

        <!-- Preview Image -->
        <img v-if="gym.logo" class="img-fluid rounded" :src="previewLogo" alt="">

        <div class="no-logo">
            <img v-if="!gym.logo" class="img-fluid rounded" :src="previewLogo" alt="">
            <h4 v-if="!gym.logo">{{ gym.title }}</h4>
        </div>
        <hr>

        <!-- Date/Time / Phone -->
        <p><i class="fa fa-phone"></i> {{ gym.phone }}</p>
        <p><i class="fa fa-envelope-o"></i> {{ gym.email }}</p>
        <p><i class="fa fa-clock-o"></i> {{ gym.work_hours }}</p>
        <hr>
        <p><i class="fa fa-map-marker"></i> {{ gym.address }}</p>
        <hr>
        <p class="lead">{{ gym.description }}</p>

        <!--<p class="text-center">Here is going to be placed the list of mine registered gyms!!!</p>-->
    </div>
</template>

<script>
    import { mapGetters } from 'vuex';

    export default {
        props: {
            id: {
                type: String,
                default: function () {
                    return '';
                }
            }
        },

        data: () => ({}),

        computed: {
            ...mapGetters({
                userId: 'authUserId',
                getGym: 'getGymById'
            }),

            gym () {
                return this.getGym;
            },

            previewLogo () {
                if (this.gym && this.gym.logo) {
                    return this.gym.logo;
                } else {
                    return 'https://hdwallsource.com/img/2014/4/free-background-wallpaper-22918-23554-hd-wallpapers.jpg';
                }
            }
        },

        async created () {
            await this.$store.dispatch('getGyms', this.userId);
            this.$store.dispatch('getGymById', this.id);
        },

        methods: {
            //
        }
    }
</script>

<style scoped>
    .card-body h1 {
        margin-top: 0 !important;
    }

    .no-logo {
        position: relative;
    }

    .no-logo img {
        height: 300px;
        width: 100%;
    }

    .no-logo h4 {
        position: absolute;
        top: 35%;
        text-align: center;
        width: 100%;
        color: #057aff;
        font-size: 70px;
        text-shadow: 2px 8px 8px rgba(212, 212, 212, 0.5), 2px -6px 25px rgba(0, 0, 0, 1);
    }
</style>



// WEBPACK FOOTER //
// resources/assets/js/pages/catalog/gym/view.vue